<template>
  <div class="page-wrapper">
    <div class="container-fluid h-100" style="overflow-y: scroll;">
      <div class="row" style="margin-top:10px; margin-bottom:10px;">
        <div class="col-12 text-left">
          <input type="date"></input>
          <input type="date"></input>
          <button class="btn btn-primary">픽업일검색</button>
          <button class="btn btn-primary">배송일검색</button>
          <input type="date" v-model="pickUpDateFrom"></input>
          <input type="date" v-model="pickUpDateTo"></input>
          <button class="btn btn-secondary" v-on:click="printSchedule"><i class="fas fa-print"></i> 스케쥴 출력하기</button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <table class="table text-left">
            <tr>
              <th>픽업일</th>
              <th>배송일</th>
              <th>상태</th>
              <th>분류</th>

              <th>신청자</th>
<!--              <th>전화번호</th>-->
<!--              <th>이메일</th>-->
<!--              <th>주소</th>-->

              <th>수취인</th>
<!--              <th>수취인 전화번호</th>-->
<!--              <th>수취인 주소</th>-->

              <th>Size</th>
              <th>AW / VW</th>
              <th>Price</th>
              <th>Pickup Price</th>
              <th>Total Price</th>
            </tr>
            <tbody>
            <tr v-for="item in items">
              <td>{{item.pickUpDate}}</td>
              <td>{{item.dispatchDate}}</td>
              <td>{{stateToString(item.state)}}</td>
              <td><span v-if="item.requestType != null">{{getRequestTypeString(item.requestType)}}</span></td>

              <td>
                {{item.sender}}<br>
                {{item.senderContact}}<br>
                {{item.senderEmail}}<br>
                {{item.senderPostCode}}<br>{{item.senderAddress1}}<br>{{item.senderAddress2}}</td>

              <td>
                {{item.receiver}}<br>
                {{item.receiverContact}}<br>
                {{item.postCode}}<br>{{item.address1}}<br>{{item.address2}}</td>

              <td>
                <div v-if="item.volumeX > 0 && item.volumeY > 0 && item.volumeZ > 0">
                {{item.volumeX}}x{{item.volumeY}}x{{item.volumeZ}} <br>
                </div>
                <template v-if="item.boxes != null && item.boxes.length > 0">
                  <div v-for="(box, bi) in item.boxes">#{{bi+1}} : {{box.x}}x{{box.y}}x{{box.z}}</div>
                </template>

              </td>
              <td>{{item.measuredWeight.toFixed(2)}} / {{(item.volumeWeight/1000).toFixed(2)}}</td>
              <td>{{(item.estimatedPrice/100).toFixed(2)}}</td>
              <td>{{(item.estimatedPickupPrice/100).toFixed(2)}}</td>
              <td>{{(item.estimatedTotalPrice/100).toFixed(2)}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="receipt-container"  v-if="scheduleList != false && scheduleList.length > 0">
      <div class="receipt-inner-container">
        <div class="scroll-container">
          <div class="container">
            <div class="row">
              <div class="col-12 text-right" style="font-size: 20px; line-height: 70px;">
                <span class="border-btn" v-on:click="processPrint"><i class="fas fa-print"></i> Print</span> <span class="border-btn" v-on:click="cancelPrint"><i class="fas fa-times"></i> Close</span>
              </div>
            </div>
          </div>

          <div class="paper-container" id="print-area">
            <div class="container-fluid print-container" style="font-size: x-small;">
              <table class="table">
                <tbody v-for="day in scheduleList">



                  <template v-for="(task, ti) in day.list">

                    <tr class="table-head-row">
                      <td v-if="ti == 0" :rowspan="5*day.list.length">{{day.date}}<br>{{dayOfWeekString(day.dayOfWeek)}}</td><td>Shipper</td><td>Collection Date</td><td>Tel</td><td>Email</td><td>Collection Address</td><td>Post Code</td><td>Description</td><td>Total Package</td><td>Total Weight</td><td>Value</td>
                    </tr>
                    <tr>
                      <td>{{task.sender}}</td><td>{{task.pickUpDate}}</td><td>{{task.senderContact}}</td><td>{{task.senderEmail}}</td><td>{{task.senderAddress1}}<br>{{task.senderAddress2}}</td><td>{{task.senderPostCode}}</td><td v-html="getItemDescription(task)"></td><td>{{task.ct}}</td><td>{{task.measuredWeight.toFixed(2)}} / {{(task.volumeWeight/1000).toFixed(2)}}</td><td>{{(task.value/100).toFixed(2)}}</td>
                    </tr>
                    <tr class="table-head-row">
                      <td>Cnee</td><td>PNO(통관부호)</td><td>tel</td><td>Email</td><td>Delivery Address</td><td>Post Code</td><td colspan="4">Est Delivery Date</td>
                    </tr>
                    <tr>
                      <td>{{task.receiver}}</td><td>{{task.customNumber}}</td><td>{{task.receiverContact}}</td><td>{{task.email}}</td><td>{{task.address1}}<br>{{task.address2}}</td><td>{{task.postCode}}</td><td colspan="4"><span v-if="task.estimatedArrivalDate != undefined">{{task.estimatedArrivalDate}}</span></td>
                    </tr>
                    <tr>
                      <td colspan="10">&nbsp;&nbsp;&nbsp;&nbsp; </td>
                    </tr>

                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {getItems, getItemRequests, convertItemState, getRequestTypeString, getCustomTypeString, getTradeTypeString, getReceiverTypeString} from "../api/item";
  import {millisToReadable, getDateString, getDayOfWeek, getDayOfWeekString} from "../api/utils";
  import EventBus from '../api/event-bus.js';
  export default {
      name: "Express",
      data() {
        return {
          items: [],
          filter: {
            dataFrom: '',
            dateTo: '',
            stateFrom: -1,
            stateTo: 5,


          },
          pickUpDateFrom:'',
          pickUpDateTo:'',
          scheduleList: false,

        }
      },
    created() {
      this.getList();
    },
    mounted() {
    },
    methods: {
      getRequestTypeString: getRequestTypeString,
      customTypeString:getCustomTypeString,
      tradeTypeString:getTradeTypeString,
      receiverTypeString:getReceiverTypeString,
      dayOfWeekString:getDayOfWeekString,
      getList: function() {
        let self = this;



        getItemRequests()
          .then(function(data) {
            if(data.success == true) {
              for(let i = 0 ; i < data.item.length > 0 ; i++) {
                if(data.item[i].boxes != null && data.item[i].boxes.length > 0) {
                  data.item[i].boxes = JSON.parse(data.item[i].boxes);
                }

              }
              self.$data.items = data.item;

            } else {
              window.alert(data.message);
            }
          })
          .catch(function(err) {
            console.log(err);
            if(err.response != undefined) {
              console.log(err.response);
            }
          })
      },
      cancelPrint: function() {
        this.$data.scheduleList = false;
      },
      printSchedule: function() {

        if(this.$data.pickUpDateFrom === '0000-00-00' || this.$data.pickUpDateFrom === '') {
          window.alert("시작 날짜를 선택해주세요");
          return;
        }
        if(this.$data.pickUpDateTo === '0000-00-00' || this.$data.pickUpDateTo === '') {
          window.alert("마지막 날짜를 선택해주세요");
          return;
        }
        if(this.$data.pickUpDateTo < this.$data.pickUpDateFrom) {
          window.alert("날짜가 옳바르지 않습니다.");
          return;
        }


        // Create Day List
        this.$data.scheduleList = [];

        let firstDay = {
          date: this.$data.pickUpDateFrom,
          dayOfWeek: getDayOfWeek(this.$data.pickUpDateFrom),
          list:[],
        }
        this.$data.scheduleList.push(firstDay);

        let finished = false;
        let diff = 1;
        while(finished == false) {
          let newDate = getDateString(this.$data.pickUpDateFrom, diff);

          let daySchedule = {
            date: newDate,
            dayOfWeek: getDayOfWeek(newDate),
            list:[],
          }
          this.$data.scheduleList.push(daySchedule);
          if(newDate === this.$data.pickUpDateTo) {
            finished = true;
          }
          diff+=1;
        }

        let condition = 'pickUpDateFrom=' + this.$data.pickUpDateFrom + '&pickUpDateTo=' + this.$data.pickUpDateTo;
        let self = this;
        getItems(condition)
        .then(function(data) {
          if(data.success == true) {
            for(let i = 0 ; i < data.item.length > 0 ; i++) {
              if(data.item[i].boxes != null && data.item[i].boxes.length > 0) {
                data.item[i].boxes = JSON.parse(data.item[i].boxes);
              }

              for(let j = 0 ; j < self.$data.scheduleList.length ; j++) {
                if(self.$data.scheduleList[j].date === data.item[i].pickUpDate) {
                  data.item[i].estimatedArrivalDate = getDateString(data.item[i].pickUpDate, 14);
                  console.log('Estimated Arrival Date ' + data.item[i].estimatedArrivalDate);
                  self.$data.scheduleList[j].list.push(data.item[i]);
                  break;
                }
              }
            }
            // self.$data.scheduleList = data.item;
            // setTimeout(self.processPrint, 1000);
          } else {
            window.alert(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response != undefined) {
            console.log(err.response);
          }
        })
      },
      getItemDescription: function(item) {
        if(item.itemList == undefined || item.itemList == null || item.itemList === '' || item.itemList.length == 0) {
          return '';
        }
        let items = JSON.parse(item.itemList);
        let list = [];
        for(let i = 0 ; i < items.length ; i++) {
          let text = items[i].name + '(' + parseFloat(items[i].value).toFixed(2)   + ') ' + items[i].amount + '개 ' + (parseFloat(items[i].value)*items[i].amount).toFixed(2);
          list.push(text);
        }
        return list.join('<br>');
      },
      processPrint: function(){
        let self = this;
        this.$htmlToPaper('print-area', ()=>{
          console.log("Printing completed or was cancelled");
          self.$data.showQrCodePrint = false;

        });
      },
      // getStateString: convertState,
      getDateTime:millisToReadable,
      stateToString:convertItemState,
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Express.vue